import Vue from "vue";
import axios from "axios";
import { Loader } from "@googlemaps/js-api-loader";

import Modal from "../vue/components/Modal.vue";

const fieldSearch = document.querySelector("#pac-input");

export default {
  init() {
    new Vue({
      components: { Modal },
      el: ".main-content",
      data() {
        return {
          isLoading: false,
          isUploading: false,
          isGeolocationLoading: false,
          openModal: false,
          mainRecaptcha: false,
          google: null,
          map: null,
          marker: null,
          form: {
            lang: LTM.lang,
            nearby: [],
            property_type: "",
            area_unit: "ไร่-งาน",
          },
          images: [],
        };
      },

      mounted() {
        this.googleMapInnit();
      },

      methods: {
        submit() {
          const form = document.querySelector(".post-property-content form");

          if (!form.checkValidity()) {
            form.classList.add("was-validated");
            form.querySelector(".main-content *:invalid").scrollIntoView();
          } else {
            this.mainRecaptcha = false
            if (grecaptcha.getResponse(mainPropertyRecaptcha).length !== 0) {

              this.isLoading = true;
              this.form.grecaptcha = grecaptcha.getResponse(mainPropertyRecaptcha);
              axios
                .post(`${LTM.api.url}v1/post-property`, this.form)
                .then(({ data }) => {
                  this.openModal = true;
                  this.form = {};
                })
                .catch((error) => { })
                .then(() => {
                  this.isLoading = false;
                  grecaptcha.reset(mainPropertyRecaptcha)
                });
            } else { this.mainRecaptcha = true }
          }
        },

        onUpload(event) {
          this.isUploading = true;
          var files = event.target.files;
          if (files.length > 0) {
            for (let index = 0; index < files.length; index++) {
              const element = files[index];
              if (!element.upload) {
                const formData = new FormData();
                formData.append("image", element);
                formData.append("lang", LTM.lang);

                axios
                  .post(`${LTM.api.url}v1/uploadimage`, formData)
                  .then(({ data }) => {
                    this.images.push(data.data);
                    files[index].upload = true;
                    this.$set(this.form, "images", this.images);
                    console.log(this.images);
                  })
                  .catch((error) => {
                    files.splice(index, 1);
                    this.images.splice(index, 1);
                  })
                  .then(() => {
                    this.isUploading = false;
                  });
              }
            }
          }
        },

        onDeleteImage(index) {
          this.images.splice(index, 1);
        },

        googleMapInnit() {

          const lat = 13.758602930297489;
          const lng = 100.56774768282104;
          const loader = new Loader({
            apiKey: "AIzaSyAOQ5Cnk_QqIO-8EiD2lVLi6QIYqTOWsl0",
            version: "weekly",
            libraries: ["places"],
          });

          loader.load().then((google) => {
            this.google = google;
            this.map = new google.maps.Map(
              document.querySelector(".post-property-gmap"),
              {
                center: { lat, lng },
                zoom: 20,
                // mapTypeControl: false,
                // streetViewControl: false,
                scrollwheel: false,
                // mapId: "5d362586e47a6815",
                // zoomControl: false,
                // disableDefaultUI: true,
                // options: {
                //   gestureHandling: 'greedy',
                // },
                mapTypeControlOptions: {
                  position: google.maps.ControlPosition.LEFT_BOTTOM,
                },
              }
            );

            this.marker = new google.maps.Marker({
              map: this.map,
              draggable: true,
              position: { lat, lng },
            });

            google.maps.event.addListener(this.marker, "dragend", (marker) => {
              const latLng = this.marker.position;
              this.setLocation(latLng.lat(), latLng.lng(), false);
            });

            const autocomplete = new google.maps.places.Autocomplete(
              fieldSearch
            );
            this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(
              fieldSearch
            );

            autocomplete.bindTo("bounds", this.map);

            autocomplete.addListener("place_changed", () => {
              const place = autocomplete.getPlace();

              if (!place.geometry || !place.geometry.location) {
                window.alert(
                  "No details available for input: '" + place.name + "'"
                );
                return;
              }

              this.setLocation(
                place.geometry.location.lat(),
                place.geometry.location.lng()
              );
            });
          });
        },

        getLocation() {
          this.isGeolocationLoading = true; // Start loading
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;
              this.setLocation(lat, lng);
              fieldSearch.value = "";
              this.isGeolocationLoading = false; // Stop loading
            }, () => {
              this.isGeolocationLoading = false; // Stop loading on error
            });
          } else {
            this.isGeolocationLoading = false; // Stop loading if geolocation is not supported
          }
        },

        setLocation(lat, lng, pantTo = true) {
          const latlng = new this.google.maps.LatLng(lat, lng);

          this.$set(this.form, "lat", lat);
          this.$set(this.form, "lng", lng);

          if (pantTo) {
            this.map.panTo(latlng);
            this.marker.setPosition(latlng);
          }
        },
      },
    });
  },
  finalize() { },
};
